import React, { Component } from 'react';
import Avatar from 'material-ui/Avatar';
import Paper from 'material-ui/Paper';
import enhanceWithClickOutside from 'react-click-outside';
import TextField from 'material-ui/TextField';
import TableActions from './TableActions';
import IconButton from 'material-ui/IconButton';
import config from '../../config/config'
import ReactTooltip from 'react-tooltip';
import { checkJapanese } from '../../lib/lib'

const UserAvatar = ({ active, name, user_id, role, direct }) => (
  <IconButton
    tooltipPosition='top-left'
    tooltip={name}
    className='flex justify-center items-center'
    style={{
      padding: 0,
      width: 46,
      height: 46,
      borderRadius: '100%',
      backgroundColor: (active) ? 'red' : 'inherit'
    }}>
    <Avatar className='w-10' src={ direct ?  "https://" + config.API_HOST + "/api/v1/image/" + name : "https://" + config.API_HOST + "/api/v1/image/" + user_id}/>
  </IconButton>
);

class ParticipantTable extends Component {
  constructor (props) {
    super(props);
    this.state = {
      name: this.props.name,
      editable: this.props.editTableStatus,
      breakOutNameError: false,
      duplicateName: false,
    };
  }

  handleClick = (e) => {
    if (this.props.user_role != "student") {
      this.setState({ editable: true });
      this.props.editTableLock(true, this.props.group)
    }
  }

  handleClickOutside () {
    const { name } = this.state;
    if (name.length > 20 || name.length === 0) {
      return this.setState({ breakOutNameError: true });
    }
    this.setState({editable: false, name});
    this.props.editTable(name,this.props.group)
  }

  handleKeyPress = (e) => {
    const { name } = this.state;
    if (e.which === 13) {
      if (name.length > 20 || name.length === 0) {
        return this.setState({ breakOutNameError: true });
      }
      if (this.props.checkTableName(name, this.props.group)) {
        this.setState({duplicateName: true});
      }else{
        this.setState({editable: false, name});
        this.props.editTable(name, this.props.group)
        this.props.editTableLock(false, this.props.group)
      }
    }
  }

  joinEmptyRoom = (e) => console.log('join room');
  handleChange = (e) => this.setState({ name: e.target.value, breakOutNameError: false });

  render () {
    return (
      <div style={{ width: 330 }} className='mb3 mr5'>
        <ReactTooltip

              place='top'
              multiline
              effect='solid'
              html />
        <div
          onClick={() => {this.handleClick()}}
          data-tip={`
                <div
                  class='pb2 custom-tooltip'>
                  ${(checkJapanese()) ? `
                    テーブル名の編集
                    ` : `
                    Edit the table name
                  `}
                </div>`}

          className='tc mb3'
          style={{ fontSize: 20, color: '#6B7C93' }}>
          {(this.state.editable) ? (
            <TextField
              name='breakoutName'
              errorText={(this.state.breakOutNameError) ? 'Please submit a valid name which should not be more than 20 chars' : (this.state.duplicateName) ?  'Use a different name!' : null}
              onKeyPress={this.handleKeyPress}
              onChange={this.handleChange}
              value={this.state.name} />
          ) : (
            <div>
              {this.state.name}
            </div>
          )}
        </div>
        <Paper
          style={{
            backgroundColor: (this.props.full) ? 'rgba(220, 12, 12, 0.2)' : '#ECECEC',
            height: 330,
            width: 330
          }}
          className='flex justify-between flex-column'>
          <div
            style={{ height: '20%' }}
            className='flex justify-around items-center'>
            {this.props.groupListObj[this.props.group] && this.props.groupListObj[this.props.group].map((val, index) => {
              if (index < 3) {
                return(
                  <div >
                    <UserAvatar active={val.speak} name={val.name} user_id={val.user_id} direct={val.direct} role={val.role} />
                  </div>
                  )}
              })}
          </div>
          <div
            style={{ height: '60%' }}
            className='flex justify-center items-center'>
            <div
              style={{
                backgroundColor: (this.props.full) ? '#F01631' : (this.props.empty) ? '#29B87A' : '#2D92EE',
                height: '100%',
                width: 211
              }}>
              {(this.props.full) ? (
                <div
                  className='h-100 w-100 flex justify-center items-center'>
                  <div className='white'>ROOM FULL</div>
                </div>
              ) : (this.props.empty) ? (
                <div
                  onClick={this.joinEmptyRoom}
                  className='h-100 w-100 flex justify-center items-center pointer'>
                  <div className='white'>JOIN ROOM</div>
                </div>
              ) : (
                <TableActions 
                  location={this.props.location} 
                  user_uid={this.props.user_uid} 
                  user_name={this.props.user_name} 
                  user_id={this.props.user_id} 
                  joinVideo={this.props.joinVideo} 
                  group={this.props.group} 
                  direct={this.props.direct} 
                  user_role={this.props.user_role} 
                  onHear={this.props.onHear} 
                  hear={( typeof this.props.hear[this.props.group] != "undefined" ) ? (this.props.hear[this.props.group]) : (false)} 
                />
              )}
            </div>
          </div>
          <div
            style={{ height: '20%' }}
            className='flex justify-around items-center z-3'>
            {this.props.groupListObj[this.props.group] && this.props.groupListObj[this.props.group].map((val, index) => {
              if (index >= 3) {
                return(
                  <div >
                    <UserAvatar active={val.speak} name={val.name} user_id={val.user_id} role={val.role} direct={val.direct} />
                  </div>
                  )}
              })}
          </div>
        </Paper>
      </div>
    );
  }
}

export default enhanceWithClickOutside(ParticipantTable);



// WEBPACK FOOTER //
// ./src/components/Table/Table.js